import React from 'react';
import DockFooter from 'slickpay/online/DockFooter.component';
import FaqPannel from 'slickpay/online/FaqPannel.component';
import StatusBannerOnline from 'slickpay/online/StatusBannerOnline.component';
import ThreeCards from 'slickpay/online/ThreeCards.component';
import TipPosAlert from 'slickpay/online/TipPosAlert.component';
import SlickPayTopContainer from 'slickpay/ordered/SlickPayTopContainer.component';

import CN from './OnlineLayout.module.scss';

const OnlineLayout = () => (
  <div data-bem="OnlineLayout" className={CN.component}>
    <SlickPayTopContainer />
    <div data-bem="OnlineLayout__status-banner" className={CN.container}>
      <StatusBannerOnline />
    </div>
    <div data-bem="OnlineLayout__tip-pos-alert" className={CN.wrap}>
      <TipPosAlert />
    </div>

    <div data-bem="OnlineLayout__faq-dock-cards" className={CN.wrap}>
      <FaqPannel />
      <DockFooter />
      <ThreeCards />
    </div>
  </div>
);

export default OnlineLayout;
